export const DEFAULT_CURRENCY = 'USD';

const currenciesInfo = {
  AUD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 2500,
      default: 6.49,
    },
    rent: {
      min: 0.01,
      max: 2500,
      default: 3.79,
    },
    sale: {
      min: 0.01,
      max: 2500,
      default: 3.79,
    },
  },
  BRL: {
    symbol: 'R$',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 6500,
      default: 16.79,
    },
    rent: {
      min: 0.05,
      max: 6500,
      default: 9.79,
    },
    sale: {
      min: 0.05,
      max: 6500,
      default: 9.79,
    },
  },
  CAD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 2500,
      default: 5.79,
    },
    rent: {
      min: 0.01,
      max: 2500,
      default: 3.49,
    },
    sale: {
      min: 0.01,
      max: 2500,
      default: 3.49,
    },
  },
  CHF: {
    symbol: 'CHF',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 2000,
      default: 4.99,
    },
    rent: {
      min: 0.05,
      max: 2000,
      default: 2.99,
    },
    sale: {
      min: 0.05,
      max: 2000,
      default: 2.99,
    },
  },
  CZK: {
    symbol: 'Kč',
    offset: 2,
    subscription: {
      min: 1,
      max: 49000,
      default: 121.49,
    },
    rent: {
      min: 1,
      max: 49000,
      default: 72.49,
    },
    sale: {
      min: 1,
      max: 49000,
      default: 72.49,
    },
  },
  DKK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 13500,
      default: 33.99,
    },
    rent: {
      min: 0.05,
      max: 13500,
      default: 19.99,
    },
    sale: {
      min: 0.05,
      max: 13500,
      default: 19.99,
    },
  },
  EUR: {
    symbol: '\u20ac',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 2000,
      default: 4.99,
    },
    rent: {
      min: 0.01,
      max: 2000,
      default: 2.99,
    },
    sale: {
      min: 0.01,
      max: 2000,
      default: 2.99,
    },
  },
  GBP: {
    symbol: '\u00a3',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 2000,
      default: 3.99,
    },
    rent: {
      min: 0.01,
      max: 2000,
      default: 2.29,
    },
    sale: {
      min: 0.01,
      max: 2000,
      default: 2.29,
    },
  },
  HKD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.1,
      max: 15500,
      default: 39,
    },
    rent: {
      min: 0.1,
      max: 15500,
      default: 24,
    },
    sale: {
      min: 0.1,
      max: 15500,
      default: 24,
    },
  },
  HUF: {
    symbol: 'Ft',
    offset: 2,
    subscription: {
      min: 5,
      max: 570000,
      default: 1389.49,
    },
    rent: {
      min: 5,
      max: 570000,
      default: 833.49,
    },
    sale: {
      min: 5,
      max: 570000,
      default: 833.49,
    },
  },
  ILS: {
    symbol: '\u20aa',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 8000,
      default: 17.9,
    },
    rent: {
      min: 0.01,
      max: 8000,
      default: 10.9,
    },
    sale: {
      min: 0.01,
      max: 8000,
      default: 10.9,
    },
  },
  JPY: {
    symbol: '\u00a5',
    offset: 0,
    subscription: {
      min: 1,
      max: 250000,
      default: 420,
    },
    rent: {
      min: 1,
      max: 250000,
      default: 360,
    },
    sale: {
      min: 1,
      max: 250000,
      default: 360,
    },
  },
  MXN: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.5,
      max: 38000,
      default: 94.49,
    },
    rent: {
      min: 0.5,
      max: 38000,
      default: 56.49,
    },
    sale: {
      min: 0.5,
      max: 38000,
      default: 56.49,
    },
  },
  MYR: {
    symbol: 'RM',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 8000,
      default: 20.49,
    },
    rent: {
      min: 0.05,
      max: 8000,
      default: 12.49,
    },
    sale: {
      min: 0.05,
      max: 8000,
      default: 12.49,
    },
  },
  NOK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 1,
      max: 17000,
      default: 41.99,
    },
    rent: {
      min: 1,
      max: 17000,
      default: 24.99,
    },
    sale: {
      min: 1,
      max: 17000,
      default: 24.99,
    },
  },
  NZD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 2500,
      default: 6.49,
    },
    rent: {
      min: 0.01,
      max: 2500,
      default: 3.79,
    },
    sale: {
      min: 0.01,
      max: 2500,
      default: 3.79,
    },
  },
  PHP: {
    symbol: '₱',
    offset: 2,
    subscription: {
      min: 1,
      max: 94500,
      default: 233.99,
    },
    rent: {
      min: 1,
      max: 94500,
      default: 139.99,
    },
    sale: {
      min: 1,
      max: 94500,
      default: 139.99,
    },
  },
  PLN: {
    symbol: 'zł',
    offset: 2,
    subscription: {
      min: 1,
      max: 8000,
      default: 19.79,
    },
    rent: {
      min: 1,
      max: 8000,
      default: 11.79,
    },
    sale: {
      min: 1,
      max: 8000,
      default: 11.79,
    },
  },
  RUB: {
    symbol: '\u20bd',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 150000,
      default: 279,
    },
    rent: {
      min: 0.01,
      max: 150000,
      default: 169,
    },
    sale: {
      min: 0.01,
      max: 150000,
      default: 169,
    },
  },
  SEK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 1,
      max: 17000,
      default: 42.79,
    },
    rent: {
      min: 1,
      max: 17000,
      default: 25.79,
    },
    sale: {
      min: 1,
      max: 17000,
      default: 25.79,
    },
  },
  SGD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 3000,
      default: 6.79,
    },
    rent: {
      min: 0.05,
      max: 3000,
      default: 4.79,
    },
    sale: {
      min: 0.05,
      max: 3000,
      default: 4.79,
    },
  },
  THB: {
    symbol: '฿',
    offset: 2,
    subscription: {
      min: 0.5,
      max: 70000,
      default: 172.79,
    },
    rent: {
      min: 0.5,
      max: 70000,
      default: 103.49,
    },
    sale: {
      min: 0.5,
      max: 70000,
      default: 103.49,
    },
  },
  TWD: {
    symbol: 'NT$',
    offset: 2,
    subscription: {
      min: 1,
      max: 65000,
      default: 158.49,
    },
    rent: {
      min: 1,
      max: 65000,
      default: 94.99,
    },
    sale: {
      min: 1,
      max: 65000,
      default: 94.99,
    },
  },
  USD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 2000,
      default: 4.99,
    },
    rent: {
      min: 0.01,
      max: 2000,
      default: 2.99,
    },
    sale: {
      min: 0.01,
      max: 2000,
      default: 2.99,
    },
  },
};

export default currenciesInfo;

export const defaultCurrencyInfo = currenciesInfo[DEFAULT_CURRENCY];



// WEBPACK FOOTER //
// ./src/shared/constants/currencies.js